document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".btn-coupon");

    buttons.forEach((btn) => {
      const container = btn.closest(".container_coupon");
      const coupon = container.querySelector(".coupon-code");
      const svg = container.querySelector(".copy_svg");
      const toCopy = container.querySelector(".to-copy");
      const copyBtn = container.querySelector(".copy");

      const originalLabel = btn.innerHTML;
      let isRevealed = false;

      btn.onclick = function () {
        if (!isRevealed) {
          btn.innerHTML = coupon.innerHTML;
          svg.classList.remove("hide-svg");
          svg.classList.add("show-svg");
          container.classList.add("coupon-revealed");
        } else {
          btn.innerHTML = originalLabel;
          svg.classList.remove("show-svg");
          svg.classList.add("hide-svg");
          container.classList.remove("coupon-revealed");
        }
        isRevealed = !isRevealed;
      };

      copyBtn.onclick = function () {
        const content = toCopy.innerText;
        navigator.clipboard.writeText(content).then(() => {
          copyBtn.classList.add("copied");
          setTimeout(() => copyBtn.classList.remove("copied"), 600);
        }).catch(err => {
          console.error("Clipboard copy failed:", err);
        });
      };
    });
});
